import { resolveOrgKpiColorToken, kpiColorCssVar, type KpiColorToken } from "@nexus/kpi-formula";

export function resolveCatalogColorVar(
  name: string,
  index: number,
  colorToken?: string | null,
): string {
  return kpiColorCssVar(resolveOrgKpiColorToken(name, index, colorToken));
}

export function asKpiColorToken(
  name: string,
  index: number,
  colorToken?: string | null,
): KpiColorToken {
  return resolveOrgKpiColorToken(name, index, colorToken);
}
